<template>
  <svg
    width="15px"
    height="26px"
    viewBox="0 0 15 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Path</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home"
        transform="translate(-233.000000, -3820.000000)"
        fill="#999999"
        fill-rule="nonzero"
      >
        <g id="Footer" transform="translate(80.000000, 3433.000000)">
          <g id="Group-16" transform="translate(0.000000, 387.000000)">
            <path
              d="M162.058771,26 L162.058771,15.6 L166.660771,15.6 L167.258771,10.4 L162.058771,10.4 L162.058771,6.58666667 C162.058771,5.252 162.431438,4.33333333 164.346771,4.33333333 L167.258771,4.33333333 L167.258771,0.199333333 C166.834104,0.138666667 164.511438,0 162.821438,0 C159.276771,0 156.858771,2.16666667 156.858771,6.12733333 L156.858771,10.4 L153.392104,10.4 L153.392104,15.6 L156.858771,15.6 L156.858771,26 L162.058771,26 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-facebook",
};
</script>

<style scoped lang="scss">
svg:hover path {
  fill: #666;
}
</style>
